import { KbCardPage } from "@/components/kb/KbCardPage";

export function Card006TraineeTrackingSystem() {
  return <KbCardPage slug="card-006-trainee-tracking-system" />;
}

(Card006TraineeTrackingSystem as unknown as { path: string }).path = "/methodology/006";
